import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IQService, IWindowService} from "angular";
import {Språk} from "felles/tjenester/i18n/Spraak";
import {SpråkvalgAvhengigheter} from "felles/tjenester/i18n/Spraakvalg";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('WebSpråkvalgAvhengigheter');

export class WebSpråkvalgAvhengigheter extends SpråkvalgAvhengigheter {

    static forInjisering() {
        return [regNavn.ng.$window, regNavn.ng.$q, WebSpråkvalgAvhengigheter]
    }

    constructor(private $window: IWindowService, private $q: IQService) {
        super();
    }

    poFiler(): string[] {
       return [
            require('../../../i18n/web/nb.po'), require('../../../i18n/felles/nb.po'),
            require('../../../i18n/web/nn.po'), require('../../../i18n/felles/nn.po'),
            require('../../../i18n/web/en.po'), require('../../../i18n/felles/en.po')
       ];
    }

    /** Leser standard språk fra nettleser */
    standardSpråk(): angular.IPromise<Språk> {
        if (this.$window.navigator['languages']) {
            /** languages er tilgjengelig, slå opp fra languages og fjern subtags */
            let tags = (<string[]>this.$window.navigator['languages']).map((s) => s.substr(0, 2));
            return this.$q.resolve(Språk.finnSpråkFraTagsEllerStandard(tags));
        }

        // language er tilgjengelig i IE11
        const tag = this.$window.navigator["language"] || this.$window.navigator["browserLanguage"] || this.$window.navigator["systemLanguage"] || this.$window.navigator["userLanguage"];

        return this.$q.resolve(Språk.finnSpråkFraTagsEllerStandard([tag]));
    }
}
